module.exports = __webpack_public_path__ + "img/start-date.a4bea1d6.svg";